import { History, Location } from 'history'
import { parse, stringify } from 'querystring'

import { Sort } from '../smart-table'
import { AllParams, Conditions, PageInfo, TableInfo } from './types'

const PAGINATION_KEY = 'page'
const ORDERING_KEY = 'orderBy'

const KEY_TYPE_INDEX = 2
const KEY_CONDITION_WITHOUT_TYPE = 1

const DIVIDER = '__'

export function getFilterConfigFromUrl(location: Location, substateName: string) {
  const searchParams = parse(location.search.replace('?', ''))

  return Object.keys(searchParams).reduce(
    (actual, key) => {
      const splittedKey = key.split(DIVIDER)

      if (!isThisTable(splittedKey, substateName)) return actual /// not for this table

      if (isTableConfigureParam(splittedKey)) {
        if (isPaginationParam(splittedKey[1])) {
          actual.skip = Number(searchParams[key])

          return actual
        }
        if (isOrderingKey(splittedKey[1])) {
          actual.sort[splittedKey[KEY_TYPE_INDEX]] = searchParams[key]

          return actual
        }
      }
      actual.conditions[splittedKey[KEY_CONDITION_WITHOUT_TYPE]] = searchParams[key]

      return actual
    },
    {
      skip: 0,
      take: 30,
      sort: {},
      conditions: {},
    }
  )
}

export function updateURLqueryState(history: History, tableId: string, conditions: TableInfo): void {
  const newUrlPath = getNewURLquery({ history, queryParams: conditions, substateName: tableId })

  history.push(newUrlPath)
}

export function generateFilterValues(newParams: TableInfo, oldParams: AllParams, substateName: string): string {
  const pageToUrl = transform({ skip: newParams.skip }, substateName, PAGINATION_KEY)
  const sortToUrl = transform(newParams.sort, substateName, ORDERING_KEY)
  const conditionsToUrl = transform(newParams.conditions, substateName)

  const searchParams = {
    ...cleanThisTableValues(oldParams, substateName),
    ...pageToUrl,
    ...sortToUrl,
    ...conditionsToUrl,
  }

  return `?${stringify(searchParams)}`
}

export function getNewURLquery({
  history,
  queryParams,
  substateName,
}: {
  queryParams: TableInfo
  history: History
  substateName: string
}): string {
  const actualQueryParams = parse<AllParams>(history.location.search.replace('?', ''))
  const newQuery = generateFilterValues(queryParams, actualQueryParams, substateName)
  const newHistoryPath = `${history.location.pathname}${newQuery}`

  return newHistoryPath
}

function isTableConfigureParam(splittedKey: string[]) {
  return splittedKey.length > 1
}

function isThisTable(splittedKey: string[], substateName: string): boolean {
  return splittedKey[0] === substateName
}

function isPaginationParam(key: string): boolean {
  return key === PAGINATION_KEY
}

function isOrderingKey(key: string): boolean {
  return key === ORDERING_KEY
}

function cleanThisTableValues(parsedSearch: Conditions, substateName: string) {
  return Object.keys(parsedSearch).reduce((previous, key) => {
    if (key.match(substateName)) {
      return previous
    }

    return { ...previous, [key]: parsedSearch[key] }
  }, {})
}

function transform(obj: PageInfo | Conditions | Sort, substate: string, type?: string): Conditions {
  return Object.keys(obj).reduce((previous, key) => {
    const keyWithCodes = `${substate}${DIVIDER}${type === undefined ? '' : `${type}${DIVIDER}`}${key}`

    return { ...previous, [keyWithCodes]: obj[key] }
  }, {})
}



// WEBPACK FOOTER //
// ./src/app/shared/utils/url-params.ts